import { state, props } from 'cerebral/tags'
import { set, when } from 'cerebral/operators'

export default [
  when(state`${props`path`}.value`),
  {
    true: [set(state`${props`path`}.isOpen`, true)],
    false: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/onFocusPill.js